import { UserI } from "@Interfaces";
import { CategoryHierarchy, ICategory } from "@Interfaces/Api/category";
import { ApiCore } from "@Services/API/Core";
import { apiProvider } from "@Services/API/Provider";

const url = "category";
const categories = new ApiCore<ICategory>({
  getAll: true,
  getSingle: true,
  remove: false,
  getSingleBySlug: true,
  url: url,
  post: false,
  put: false,
  patch: false,
});

categories.getHierarchy = (): Promise<CategoryHierarchy> => {
  return apiProvider.getAll(`${url}/hierarchy`);
};

export { categories as apiCategories };
